import Base from './Base';
import Broadcast from '../models/Broadcast';

export default class Broadcasts extends Base {
    get models() {
        const collection = this.data.map(item => new Broadcast(item));
        collection.collection = this;

        return collection;
    }
}
